var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('iframe',{ref:"iframe",attrs:{"width":_vm.iframeWidth,"height":_vm.iframeHeight,"src":_vm.iframeUrl},on:{"load":_vm.resizeIframe}})])
}
var staticRenderFns = []

export { render, staticRenderFns }